import React,{useState,useRef} from 'react';
import Wrp from '../../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
import Icons from "../../../../Components/Icons/Icons";
import * as ShipConstants from '../../../../Global/Constants';
import { callPUT } from '../../../../Utils/ApiUtil';

const Calculation = (props) => {
	const {currState,toggleSideBar,formulaDataChangeHandler,drillDownNextLevel,goBackDrillDown,toggleCalculation,saveCalculation} = props;
    const {variableList,isSideBarOpen,windowFields,metaInfo,isCalculationOpen,formulaData,drillDownData,windowFieldsExist,excelDetail} = currState;
    const syntaxRef = useRef(null);
    const [errorMsg, setErrorMsg] = useState({
        isError:false,
        msg:'',
        data:null,
        isSuccess:false
    });
    console.log(excelDetail);
    let functionList = [];
    if(metaInfo && metaInfo.functions && metaInfo.functions.length > 0) {
        if(formulaData.functionType < 0) {
            metaInfo.functions.map((item,ind) => {
                if(item && item.function_list) {
                    item.function_list.map((funcItem,funcInd) => {
                        functionList.push(funcItem);            
                    })
                }
            })
        }else {
            functionList = metaInfo.functions[formulaData.functionType].function_list;  
        }
    }

    const chooseFuntion = (e) => {
        const {name,value} = e.target;
        console.log(name,value);
        let functObj = null;
        if(name === 'functionVal') {
            const objVal = e.target.getAttribute("functionobj");
            if(objVal) {
                functObj = JSON.parse(objVal);
            }
        }
        formulaDataChangeHandler(name,value,functObj);
    }

    const addExpression = () => {
        const params = props.match.params;
        const {functionVal,operator,fieldVal,formula_expression} = formulaData;

        let exp = formula_expression ? formula_expression : '';
        let myElement = document.getElementById('formula_expression');
        let startPosition = myElement.selectionStart;
        let endPosition = myElement.selectionEnd;

        let textBeforeCursorPosition = exp.substring(0, startPosition)
        let textAfterCursorPosition = exp.substring(startPosition, exp.length)

        let existVal = (formula_expression !== undefined && formula_expression !== null) ? formula_expression : '';
        let absWin = excelDetail.variable_mapping === false ? excelDetail.window_name : "";
        console.log(drillDownData);
        if(drillDownData) {
            drillDownData.map((item,ind) => {
                if(excelDetail.variable_mapping === true) {
                    absWin += ind === 0 ? item.api_name : "."+item.api_name;
                }else{
                    absWin = absWin+'.'+item.api_field_name;  
                }
            })
        }
        // console.log(drillDownData, absWin);
        let fields = fieldVal;
        if(fields && fields !== '') {
          fields = '${'+absWin+'.'+fields+'}';
        }else {
          fields = '';
        }

        let val = '';
        if(functionVal && functionVal !== '') {
            val = functionVal+'('+fields+')'+operator;
        }else {
            val = fields+' '+operator;
        }
        // const val = functionVal+'('+fields+')'+operator;

        const val1 = textBeforeCursorPosition + val + textAfterCursorPosition;
        console.log(val1);
        formulaDataChangeHandler('formula_expression',val1);
    }

    const checkSyntax = (isSave=false) => {
        const {formula_expression,formula_returntype} = formulaData;
        let label = {};
        label['blocks'] = [{text:'label'}];
        const body = {"is_formula_field": true, "formula_expression":formula_expression,"formula_returntype":formula_returntype,label:label}
        console.log(JSON.stringify(body));
        callPUT("layouts/check-formula-syntax",body)
        .then(response => {
          console.log(response);
          const responseData = response.data;
          if(responseData.code !== ShipConstants.API_STATUS_SUCCESS) {
              if(responseData.violations) {
                const lists = {...errorMsg}
                let errMsg = '';//responseData.message;
                responseData.violations.map((item,ind) => {
                    const data = /*item.field_name+':'+*/item.message;
                    errMsg += ind === 0 ? data : ', '+data;
                })
                if(errMsg === '') {
                    lists['isError'] = false;
                    errMsg = 'No Syntax Errors';
                }else {
                    lists['isError'] = true;
                }
                lists['data'] = responseData;
                lists['msg'] = errMsg;
                lists['isSuccess'] = false;
                setErrorMsg(lists);
                syntaxRef.current.focus();
              }else {
                setErrorMsg({
                    isError:false,
                    msg:'',
                    data:null,
                    isSuccess:false
                });
                if(isSave === true) {
                    saveCalculation();
                    clearError();
                }
              }
            }else {
                setErrorMsg({
                    isError:false,
                    msg:'',
                    data:null,
                    isSuccess:true
                });
                if(isSave === true) {
                    saveCalculation();
                    clearError();
                }
            }
        })
        .catch(err => {
          console.log(err);
        })
    }

    const closeModel = () => {
        clearError();
        toggleCalculation('');
    }

    const clearError = () => {
        setErrorMsg({
            isError:false,
            msg:'',
            data:null,
            isSuccess:false
        });
    }

    const updateDecimalVal = (dir) => {
        const current = parseInt(formulaData.decimal, 10);
        const n = Number.isNaN(current) ? 2 : current;
        const next = dir === 'plus' ? Math.min(n + 1, 15) : Math.max(n - 1, 0);
        formulaDataChangeHandler('decimal', next);
    }

    let functObj = formulaData.functionObj;
	return (
		<Modal size="fullscreen" show={isCalculationOpen} onHide={closeModel}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2 mb-0"> Advance Calculation </h5>
                
            </Modal.Header>
            <Modal.Body>
                <div className="row pl-2">
                    <h5 className="mb-3 border-bottom"> Formula Options </h5>
                </div>
                <div className="row pb-4">
                    <div className="col-6">
                        <label className="fourth_dark_color form-label"> Formula Return Type:</label>
                        <select className="form-control" value={formulaData.formula_returntype} name="formula_returntype" onChange={e => chooseFuntion(e)}>
                        <option value="">&nbsp;</option>
                        {
                            metaInfo && metaInfo.supported_fields ?
                                metaInfo.supported_fields.map((metaItem,metaInd) => {
                                    return <option key={metaInd} value={metaItem.element}>{metaItem.return_type}</option>
                                })
                            : null
                        }
                        </select>
                    </div>
                    { formulaData.formula_returntype === 'Currency' || formulaData.formula_returntype === 'Decimal' || formulaData.formula_returntype === 'Percent' ?
                    <div className="col-6"> 
                        <label className="fourth_dark_color form-label"> Number of decimal places </label>
                        <div className="input-group">
                            <span className="input-group-btn input-group-prepend">
                                <button className="btn btn-primary" type="button" onClick={e=>updateDecimalVal('minus')}> - </button>
                            </span>
                            <input type="number" className="form-control" value={formulaData.decimal != null ? formulaData.decimal : 2} name="decimal" onChange={e => chooseFuntion(e)}/>
                            <span className="input-group-btn d-flex">
                                <button className="btn btn-primary" type="button" onClick={e=>updateDecimalVal('plus')}> + </button>
                            </span>
                        </div> 
                    </div> 
                    : null } 
                </div>
                <div className="row pl-2">
                    <h5 className="mb-3 border-bottom"> Choose Function, Field & Operator </h5>
                    <div className="selectgroup">
                        <label className="selectgroup-item">
                            <input type="radio" 
                                name="functionType" 
                                onChange={e=>chooseFuntion(e)}
                                checked={parseInt(formulaData.functionType) === -1 ? true : false }
                                value={-1}  
                                className="selectgroup-input" />
                            <span className="selectgroup-button selectgroup-button-icon"> All </span>
                        </label>
                        { metaInfo && metaInfo.functions ?
                            metaInfo.functions.map((metaItem,metaInd) => {
                                return (
                                    <label key={metaInd} className="selectgroup-item">
                                        <input type="radio" name="functionType" 
                                            value={metaInd} 
                                            onChange={e=>chooseFuntion(e)} 
                                            checked={parseInt(formulaData.functionType) === metaInd ? true : false }
                                            className="selectgroup-input"  />
                                        <span className="selectgroup-button selectgroup-button-icon"> {metaItem.category} </span>
                                    </label>
                                )
                            })
                        : null }
                    </div>
                </div>
                <div className="row">
                    <div className="mt-3 col">
                        <div className="d-flex justify-content-between">
                            <div className="col-5 pr-0">
                                <div className="card mb-0">
                                    <div className="card-header p-1">
                                        <div className="card-title">List of Functions </div>
                                    </div>
                                    <div className="card-body pt-0 pb-0 fixedHeight">
                                        <div className="card-list">
                                            <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                                                <div className="selectgroup selectgroup-secondary selectgroup-pills w-100">
                                                    <label className="selectgroup-item w-100">
                                                        <input 
                                                            type="radio" 
                                                            name="functionVal" 
                                                            onChange={e=>chooseFuntion(e)}
                                                            className="selectgroup-input" 
                                                            value=""
                                                            functionobj={null}
                                                            checked={formulaData.functionVal === '' ? true : false }
                                                        />
                                                        <span className="selectgroup-button selectgroup-button-icon"> None </span>
                                                    </label>
                                                </div>
                                            </div>
                                        { functionList ?
                                                functionList.map((item,ind) => {
                                                return (
                                                    <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                                                        <div className="selectgroup selectgroup-secondary selectgroup-pills w-100">
                                                            <label className="selectgroup-item w-100">
                                                                <input 
                                                                    type="radio" 
                                                                    name="functionVal" 
                                                                    className="selectgroup-input" 
                                                                    value={item.function_name}
                                                                    functionobj={JSON.stringify(item)}
                                                                    onChange={e=>chooseFuntion(e)} 
                                                                    checked={formulaData.functionVal === item.function_name ? true : false }
                                                                />
                                                                <span className="selectgroup-button selectgroup-button-icon"> {item.function_name} </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                )
                                                })
                                            : null }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-2 pr-0 pl-2">
                                <div className="card mb-0">
                                    <div className="card-header p-1">
                                        <div className="card-title"> Operators </div>
                                    </div>
                                    <div className="card-body pt-0 pb-0 fixedHeight"> 
                                        <div className="card-list">
                                            <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                                                <div className="selectgroup selectgroup-secondary selectgroup-pills w-100">
                                                    <label className="selectgroup-item w-100">
                                                        <input 
                                                            type="radio" 
                                                            name="operator" 
                                                            className="selectgroup-input"
                                                            value="" 
                                                            onChange={e=>chooseFuntion(e)}
                                                            checked={formulaData.operator === '' ? true : false }
                                                        />
                                                        <span className="selectgroup-button selectgroup-button-icon"> None </span>
                                                    </label>
                                                </div>
                                            </div>
                                        {
                                        metaInfo && metaInfo.operators ?
                                            metaInfo.operators.map((operatorCategoty,operetorInd) => {
                                                return operatorCategoty.symbols.map((operetorItem,opIndex)=>{
                                                    return (
                                                        <div className="w-100 d-flex align-items-center justify-content-between mb-2" key={operetorInd+'-'+opIndex}>
                                                            <div className="selectgroup selectgroup-secondary selectgroup-pills w-100">
                                                                <label className="selectgroup-item w-100">
                                                                    <input 
                                                                        type="radio" 
                                                                        name="operator" 
                                                                        className="selectgroup-input"
                                                                        value={operetorItem} 
                                                                        onChange={e=>chooseFuntion(e)}
                                                                        checked={formulaData.operator === operetorItem ? true : false }
                                                                    />
                                                                    <span className="selectgroup-button selectgroup-button-icon"> {operetorItem}  </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )
                                                });
                                            })
                                        : null
                                        }
                                        </div>
                                    </div>
                                </div>
                             
                            </div>
                            <div className="col-5 pl-2">
                                <div className="card mb-0">
                                    <div className="card-header p-1">
                                        <div className="card-title">Input Fields <code> (Add to selected fields) </code></div>
                                        <ul className="breadcrumbs text-small">
                                          <li className="nav-item" onClick={e=>goBackDrillDown(-1)} >
                                            <a className=""> 
                                            {excelDetail && excelDetail.variable_mapping === false ?
                                                excelDetail.window_name : "Fields"} </a>
                                          </li>
                                          <li className="separator">
                                            <i className="fas fa-chevron-right fourth_light_color"></i>
                                          </li>
                                        {
                                          drillDownData ?
                                              drillDownData.map((item,ind) => {
                                                return (
                                                  <Wrp key={ind}>
                                                    <li className="nav-item" onClick={e=>goBackDrillDown(ind)} >
                                                    {excelDetail && excelDetail.variable_mapping === false ?
                                                      <a className=""> {item.field_name} </a>
                                                    : <a className=""> {item.variable_name ? item.variable_name : item.name} </a> }
                                                    </li>
                                                    <li className="separator">
                                                    <i className="fas fa-chevron-right fourth_light_color"></i>
                                                    </li>
                                                  </Wrp>
                                                )
                                              })
                                          : null
                                        }
                                        </ul>
                                      </div>
                                    <div className="card-body pt-0 pb-0 fixedHeight">
                                    {excelDetail && excelDetail.variable_mapping === true ?
                                        <div className="card-list">
                                        { variableList && variableList.length>0 ? 
                                                variableList.map((arr,ind) => {
                                                    //const varNam = arr.variable_name?arr.variable_name:arr.name;
                                                    const varNam = arr.api_name;
                                                    return (
                                                        <div key={ind} className="w-100 d-flex align-items-center justify-content-center mb-1">
                                                          <div className="w-100 ">
                                                            <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
                                                              <input type="radio" 
                                                                name={"fieldVal"} 
                                                                value={varNam} 
                                                                className=" "
                                                                onChange={ arr.fields && arr.fields.length>0 ? null : e=>chooseFuntion(e)}
                                                                checked={varNam === formulaData.fieldVal ? true : false}
                                                               />
                                                                <span className="pl-3">{varNam}</span>
                                                            </label>
                                                          </div>
                                                          {
                                                            arr.fields && arr.fields.length>0 ?
                                                                <div>   
                                                                    <a className="cursor-pointer" onClick={e=>drillDownNextLevel(JSON.stringify(arr))}>
                                                                        <Icons iconType="IconArrowR" /> 
                                                                    </a>
                                                                </div>
                                                            : null
                                                          }
                                                        </div>
                                                        )
                                                })
                                            : null }
                                        </div>
                                        :
                                        <div className="card-list">
                                        { windowFields && windowFields.fields_with_filters && windowFields.fields_with_filters.window_fields ? 
                                                windowFields.fields_with_filters.window_fields.map((arr,ind) => {
                                                    //const varNam = arr.variable_name?arr.variable_name:arr.name;
                                                    const varNam = arr.api_field_name;
                                                    return (
                                                        <div key={ind} className="w-100 d-flex align-items-center justify-content-center mb-1">
                                                          <div className="w-100 ">
                                                            <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
                                                              <input type="radio" 
                                                                name={"fieldVal"} 
                                                                value={arr.api_field_name} 
                                                                className=" "
                                                                onChange={ arr.dependent_layout ? null : e=>chooseFuntion(e)}
                                                                checked={varNam === formulaData.fieldVal ? true : false}
                                                               />
                                                                <span className="pl-3">{arr.field_name}</span>
                                                            </label>
                                                          </div>
                                                          {
                                                            arr.dependent_layout ?
                                                                <div>   
                                                                    <a className="cursor-pointer" onClick={e=>drillDownNextLevel(JSON.stringify(arr))}>
                                                                        <Icons iconType="IconArrowR" /> 
                                                                    </a>
                                                                </div>
                                                            : null
                                                          }
                                                        </div>
                                                        )
                                                })
                                            : null }
                                        </div>
                                    }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 col-centered mt-2 text-center"> 
                        <span className="btn btn-link" onClick={addExpression}><i className="fas fa-angle-double-down"></i> Insert Below </span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <div className="form-group"> 
                            <h5 className="mb-3 mt-4 border-bottom"> Function Usage </h5>
                            <div className="card mb-0">
                                <div className="card-body pb-0 px-3 pt-2">
                                 
                                {
                                    functObj ?
                                        <ol className="activity-feed mb-0 p-0">
                                            <li className="feed-item feed-item-secondary pb-2">
                                                <time className="text">Function :</time>    
                                                <span className="date primary_color"> {functObj.function_name} </span>
                                            </li>
                                            <li className="feed-item feed-item-success pb-2">
                                                <time className="text">Description  :</time>    
                                                <span className="date primary_color"> {functObj.function_desc}</span>
                                            </li>
                                            <li className="feed-item feed-item-info pb-2">
                                                <time className="text">Syntax :</time>  
                                                <span className="date primary_color"> {functObj.function_syntax} </span>
                                            </li>
                                            <li className="feed-item feed-item-warning pb-2">
                                                <time className="text">Example :</time> 
                                                <span className="date primary_color"> {functObj.example} </span>
                                            </li>
                                            <li className="feed-item feed-item-info pb-2">
                                                <time className="text">Output :</time> 
                                                <span className="date primary_color"> {functObj.output_type} </span>
                                            </li>
                                        </ol>
                                    : <ol className="activity-feed mb-0 p-0">
                                            <li className="feed-item feed-item-secondary pb-2">
                                                <span className="date primary_color"> NONE </span>
                                            </li>
                                      </ol>
                                }
                                    
                                </div>
                            </div> 
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="form-group"> 
                            <h5 className="mb-3 mt-4 border-bottom"> Formula Expression </h5> 

                            <div className="input-group"> 
                                <textarea className="form-control mandatory" 
                                    onChange={e=>chooseFuntion(e)}
                                    value={formulaData.formula_expression} 
                                    id="formula_expression" 
                                    name="formula_expression"
                                    ref={syntaxRef}></textarea>   
                                <span className="input-group-btn d-flex">
                                    <button onClick={e=>checkSyntax()} className="btn btn-primary" type="button" > Check Syntax </button>
                                </span>
                            </div>
                            <div className="">
                            {
                                errorMsg.data !== null ?
                                    <code>{errorMsg.msg}</code>
                                : null
                            }
                            {
                                errorMsg.isSuccess && errorMsg.isSuccess === true ?
                                    <code style={{color:'green'}}>No Syntax Error</code>
                                : null
                            }
                            </div> 
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-between">
              
                    {/*<a onClick={toggleCalculation} className="btn btn-border border-default mr-2"> Cancel </a> 
                    <a onClick={props.saveChargeDetails} className="btn primary_bg"> Save </a> */}
                    
                        <a onClick={closeModel} className="btn btn-border border-default mr-2" data-dismiss="modal"> Cancel </a>    
                        {/*<a onClick={e=> [saveCalculation(),clearError()]} className="btn primary_bg"> Add </a> */}
                        <a onClick={e=>checkSyntax(true)} className="btn primary_bg"> Add </a> 
                    
                
            </Modal.Footer>
		</Modal>
	);
}

export default withRouter(Calculation);